import React from "react";

const Pay = () => (
  <>
    <section className={"effect-section theme-bg parallax"}>
      <div className={"container"}>
        {/*<FloatButton/>*/}

        <div
          className={
            "row full-screen align-items-center p-100px-tb justify-content-center"
          }
        >
          <div className={"col-lg-12 col-md-7 m-30px-tb"}>
            <h1 className={"display-4 m-20px-b white-color"}>Payment plans</h1>
            <label htmlFor={"newsletter white-color"}>
              Start the technological growth of your business
            </label>
          </div>

          <div className={"col-lg-6 col-md-7 m-30px-tb"}>
            <div className={"card card-body"}>
              <h5>Development plan</h5>

              <p>
                &rarr; Develop your product (Web Page, APP, Online Store)
                <br></br>
                &rarr; The development cost of your product is paid in two or
                three exhibitions, depending on the project.
              </p>

              <br></br>
              <button
                className={"m-btn m-btn-radius m-btn-green flex-shrink-0"}
                type={"submit"}
              >
                I want to start my project with this plan
              </button>
            </div>
          </div>
          <div className={"col-lg-6 col-md-7 m-30px-tb"}>
            <div className={"card card-body"}>
              <h5>Partner Plan</h5>
              <p>
                &rarr; Develop your product (Web Page, APP, Online Store)
                <br></br>
                The development cost of your product is dbilled monthly.
                <br></br>
                &rarr; Medium and long term agreement.
                <br></br>
                &rarr; Constant counseling.
              </p>

              <button
                className={"m-btn m-btn-radius m-btn-green flex-shrink-0"}
                type={"submit"}
              >
                I want to start my project with this plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Pay;
